import { Checkbox } from '@systemeio/ui'
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import {
  eventTypeDescriptionLocoKeys,
  eventTypeTitleLocoKeys,
} from '../constants/event-type-translation-dictionary'
import { WebhookSubscriptionEventEnum } from '../types/webhook-settings-interface'

interface EventTypesSelectProps {
  selected: Record<WebhookSubscriptionEventEnum, boolean>
  onSelect: (eventType: WebhookSubscriptionEventEnum) => void
  disabled?: boolean
  error?: string
}

const eventTypes = Object.values(WebhookSubscriptionEventEnum)

const EventTypesSelect = ({ selected, onSelect, disabled, error }: EventTypesSelectProps) => {
  const { t } = useLocoTranslation()
  const handleChange = (eventType: WebhookSubscriptionEventEnum) => () => onSelect(eventType)

  return (
    <div className="p-6">
      <div className="grid grid-cols-2 gap-5">
        {eventTypes.map(et => (
          <Checkbox
            disabled={disabled ?? false}
            key={et}
            onChange={handleChange(et)}
            className="items-start"
            label={
              <>
                <span className="text-text-primary">{t(eventTypeTitleLocoKeys[et])}</span>
                <span className="text-text-primary/50">{t(eventTypeDescriptionLocoKeys[et])}</span>
              </>
            }
            labelClassName="flex flex-col"
            value={selected[et]}
          />
        ))}
      </div>
      {error && <FieldErrorAndDescription error={error} errorClassName="mt-5" />}
    </div>
  )
}

export default EventTypesSelect
